import template from './log-detail-list.html';
import controller from './log-detail-list.controller';

let logDetailListComponent = {
  bindings: {},
  template,
  controller
};

export default logDetailListComponent;


// WEBPACK FOOTER //
// ./client/app/components/faq/log-detail-list.component.js